import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { customLoader } from '../../../utils/customLoaderImage';
import { valueToBRL } from '../../../utils/formatCoin';

import style from './cardImovel.module.scss';

const parse = require('html-react-parser');

export default function CardImovel({ imovel }) {
  const router = useRouter();

  if (!imovel) return null;

  return (
    <Link
      key={imovel.id}
      href={{
        pathname: `/apartamentos-a-venda/${imovel.slug}`,
        query: router.query,
      }}
      passHref>
      <div
        className={style.cardImovel}
        role='button'
        onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.click()}
        tabIndex={0}>
        <figure className={style.image}>
          {imovel.foto && (
            <Image
              src={imovel.thumbnail || '/img/image_icon.png'}
              loader={customLoader}
              alt={`Imagem do ${imovel.nome}`}
              objectFit='cover'
              layout='responsive'
              width={300}
              height={300}
              priority
            />
          )}
          <figcaption>{`Imagem do ${imovel.nome}`}</figcaption>
        </figure>
        <div className={style.text}>
          {imovel.faseObra && <h4>{imovel.faseObra}</h4>}
          <h3>{imovel.nome}</h3>
          <span>{`${imovel.cidade} - ${imovel.bairro}`}</span>
          <span>{parse(imovel.variacaoTipologia)}</span>
          {process.env.FEATURE_FLAG_DATA_ENTREGA
            ? imovel.dataDeEntrega && (
            <span>
              Data de Entrega:
              {` ${new Date(imovel.dataDeEntrega).toLocaleDateString('pt-BR', {
                month: '2-digit',
                year: 'numeric',
              })}`}
            </span>
            )
            : null}
          <span>{parse(imovel.numeroDeGaragensDescricao)}</span>
          {imovel.faseObra !== 'Pré-lançamento' && (
            <span>{`A partir de ${valueToBRL(imovel.valorMinimo)} até ${valueToBRL(imovel.valorMaximo)}`}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
